//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconCommentConvoFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.5 7V16.5H12.17L9.22998 20H13.03L14.71 22H17V20H23V7H18.5Z" fill="currentColor" /><path d="M17 15V2H1V15H7V18H8.95L11.47 15H17Z" fill="currentColor" /></svg>;
}
export default IconCommentConvoFill;